// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".error[data-v-2aa53bab]{display:flex;width:100%;height:70vh}.error__content[data-v-2aa53bab]{margin:auto;text-align:center}.error__content h2[data-v-2aa53bab]{color:#888c93;text-transform:capitalize;font-size:1.5rem;line-height:1.5rem}.error__content a[data-v-2aa53bab]{color:#fff;font-weight:700;font-size:1.25rem;line-height:1.5rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
